var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106713",
    "data-name": "Group 106713",
    transform: "translate(163.447 -68.447) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10934",
    "data-name": "Rectangle 10934",
    transform: "translate(68.447 147.447)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106676",
    "data-name": "Group 106676",
    transform: "translate(69.329 150.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49487",
    "data-name": "Path 49487",
    d: "M2.028,88.893H8.9a.593.593,0,0,0,0-1.186H2.028l1.36-1.36a.593.593,0,0,0-.839-.839L.176,87.88c-.014.014-.027.028-.039.043l-.016.021L.1,87.97.087,88l-.014.024c0,.009-.009.018-.013.027l-.012.026c0,.009-.007.018-.01.027s-.007.019-.01.028,0,.018-.007.027-.005.019-.007.029,0,.021,0,.031,0,.017,0,.026a.6.6,0,0,0,0,.117c0,.009,0,.017,0,.026s0,.021,0,.031,0,.02.007.029,0,.018.007.027.006.019.01.028.006.018.01.027l.012.026.013.027.014.024.016.026.019.025.016.021c.012.015.025.029.039.043h0l2.373,2.373a.593.593,0,0,0,.839-.839Zm12.077,3.342.016-.021.019-.025.016-.026.014-.024.013-.027.012-.026c0-.009.007-.018.01-.027s.007-.019.01-.028,0-.018.007-.027.005-.019.007-.029,0-.021,0-.031,0-.017,0-.026a.6.6,0,0,0,0-.117c0-.009,0-.017,0-.026s0-.021,0-.031,0-.02-.007-.029,0-.018-.007-.027-.006-.019-.01-.028-.006-.018-.01-.027l-.012-.026c0-.009-.008-.018-.013-.027l-.014-.024-.016-.026-.019-.025-.016-.021q-.018-.022-.039-.043h0l-2.373-2.373a.593.593,0,1,0-.839.839l1.36,1.36H5.341a.593.593,0,0,0,0,1.186h6.873l-1.36,1.36a.593.593,0,1,0,.839.839l2.373-2.373h0Q14.087,92.257,14.105,92.235Z",
    transform: "translate(-0.003 -85.334)",
    fill: "#80838e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/Exchange.f5c45e3dbed2749f6cb372ff2f8226b0.svg";
export { ForwardRef as ReactComponent };